import { useState, useEffect } from 'react';
import { fetchAdminCompetitions } from '../../api/api';

export function useAdminCompetitions() {
  const [competitions, setCompetitions] = useState([]);

  useEffect(() => {
    fetchAdminCompetitions()
    .then(json => {
      setCompetitions(json)
    })
  }, []);

  return competitions;
}